// @ts-ignore TK: need to use assert for ESBuild, TSC doesn't like it anymore
import english from '../../static/lang/en.json' assert {type: 'json'};

export class Localization {
    currentLanguage: string;
    private translations: {[key: string]: string} = english;

    private static _instance: Localization;
    private _isLoaded = false;
    get isLoaded(): boolean {
        return this._isLoaded;
    }

    static get instance(): Localization {
        return this._instance ?? (this._instance = new Localization());
    }

    private constructor() {
        this.currentLanguage = this._getLanguage();
        console.log('Current language:', this.currentLanguage);
        this._loadLanguage(this.currentLanguage);
    }

    private _availableLanguages = ['en', 'de', 'fr', 'es', 'nl'];
    private _userLanguages = navigator.languages.map((lang) => lang.split('-')[0]);

    private _getLanguageFromURL(): string | null {
        const queryParams = new URLSearchParams(window.location.search);
        return queryParams.get('language');
    }

    private _getLanguage(): string {
        const overrideLanguage = this._getLanguageFromURL();
        const languagesToCheck = [overrideLanguage, ...this._userLanguages, 'en'];

        for (const language of languagesToCheck) {
            if (language && this._availableLanguages.includes(language)) {
                return language;
            }
        }

        return 'en'; // always default to English
    }

    private async _loadLanguage(language: string): Promise<void> {
        if (language === 'en') {
            this._isLoaded = true;
            return; // English is already loaded
        }
        const response = await fetch(`/lang/${language}.json`);
        if (response.ok) {
            this.translations = await response.json();
            localStorage.setItem(
                `translations_${language}`,
                JSON.stringify(this.translations)
            );
        } else {
            console.error(`Failed to load language file for ${language}`);
        }
        // wether the file is loaded or not, we set the loaded state to true.
        this._isLoaded = true;
    }

    async setLanguage(language: string): Promise<void> {
        if (this._availableLanguages.includes(language)) {
            this.currentLanguage = language;
            await this._loadLanguage(language);
        }
    }

    get(key: string): string {
        const str = this.translations[key];
        if (!str) {
            console.warn(`Missing translation for key: ${key}`);
            return key;
        }
        return str.replace('\\n', '\n');
    }
}
